import { Link } from "react-router-dom";
import { Footer } from "@/components/activehuman/Footer";

const Terms = () => {
  return (
    <div data-testid="terms-page" className="bg-[#FDFBF7] text-[#1A362D] min-h-screen">
      <header className="border-b border-[#E5E8E3]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link to="/" data-testid="terms-back-home" className="font-serif-display text-2xl">
            activehuman<span className="text-[#C29B62]">.</span>
          </Link>
          <Link to="/" className="text-sm uppercase tracking-[0.2em] text-[#1A362D] activehuman-link-underline">
            ← Back home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="text-xs uppercase tracking-[0.28em] text-[#C29B62] font-semibold mb-4">Legal</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A362D] tracking-tight font-medium leading-tight">
          Terms of Service
        </h1>
        <p className="mt-4 text-sm text-[#4A5D56]">Last updated: December 2025 · Placeholder</p>

        <div className="mt-12 space-y-6 text-[#4A5D56] font-light text-base md:text-lg leading-relaxed">
          <p>
            Welcome to Activehuman. By using this website, you agree to the following placeholder terms. These will be
            replaced with a full, definitive Terms of Service prior to any product sale.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">
            Pre-launch website
          </h2>
          <p>
            This website is currently a pre-launch informational site. No products are available for purchase. Content,
            features, claims and packaging shown may change before launch.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">Nutritional use</h2>
          <p>
            Activehuman products, including Vitamin D3 Drops, are nutritional supplements. They are not intended to
            diagnose, treat, cure, or prevent any disease. Always consult a qualified healthcare professional before
            starting any new supplement, especially if you are pregnant, lactating, on medication, or have a medical
            condition.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">Communications</h2>
          <p>
            By submitting your email through the "Notify Me" form, you agree to receive launch-related communications
            from Activehuman. You can opt out at any time.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">Intellectual property</h2>
          <p>
            All brand assets, product names, copy, and imagery on this site are the property of Activehuman and may not
            be reproduced without permission.
          </p>

          <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A362D] font-medium pt-6">Contact</h2>
          <p>
            Questions? Write to us at{" "}
            <a className="activehuman-link-underline text-[#1A362D]" href="mailto:hello@theactivehuman.com">
              hello@theactivehuman.com
            </a>
            .
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
